import React, { FC } from 'react';

const StarsConfetti: FC = () => {
  return (
    <svg viewBox="0 0 370 703" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1744_16543)">
        <path
          d="M23.0959 2.64615L24.1536 8.05966L29.4395 10.1145L24.3564 12.9572L23.754 18.4967L19.5537 14.8411L13.8944 16.2096L16.3824 11.1058L13.4882 6.41297L19.2252 6.91467L23.0959 2.64615Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip1_1744_16543)">
        <path
          d="M184.676 5.55699L185.988 10.9145L191.365 12.7173L186.422 15.797L186.082 21.3588L181.714 17.9056L176.125 19.54L178.369 14.3243L175.257 9.7735L181.011 10.0036L184.676 5.55699Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip2_1744_16543)">
        <path
          d="M295.519 9.15308L293.507 14.2889L296.865 18.859L291.051 18.5306L287.57 22.882L285.987 17.5435L280.477 15.662L285.315 12.6899L285.39 7.17684L289.963 10.6784L295.519 9.15308Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip3_1744_16543)">
        <path
          d="M22.524 124.357L18.6131 128.246L19.8449 133.782L14.6555 131.138L9.71656 133.718L10.4189 128.194L6.13425 124.252L11.7597 123.482L14.0504 118.466L16.8239 123.513L22.524 124.357Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip4_1744_16543)">
        <path
          d="M354.368 15.1576L358.461 18.8557L363.923 17.3306L361.56 22.6535L364.399 27.4479L358.846 27.0409L355.137 31.5296L354.068 25.9532L348.938 23.9331L353.83 20.8946L354.368 15.1576Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip5_1744_16543)">
        <path
          d="M117.637 27.6422L112.737 25.1086L107.844 27.9748L108.773 22.2255L104.806 18.3125L110.28 17.2914L112.723 12.0062L115.177 17.1262L120.652 17.7729L116.696 21.9574L117.637 27.6422Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip6_1744_16543)">
        <path
          d="M236.899 15.3784L241.195 18.8369L246.562 17.0025L244.506 22.4516L247.615 27.0761L242.047 26.9868L238.601 31.6798L237.215 26.1735L231.978 24.4495L236.689 21.1367L236.899 15.3784Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip7_1744_16543)">
        <path
          d="M360.274 180.085L359.217 185.499L363.341 189.392L357.562 190.113L354.92 195.019L352.403 190.051L346.645 189.19L350.871 185.397L349.955 179.96L355.081 182.584L360.274 180.085Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip8_1744_16543)">
        <path
          d="M21.0524 256.433L20.1558 261.876L24.3933 265.645L18.6379 266.536L16.1415 271.518L13.4798 266.627L7.69848 265.936L11.8102 262.02L10.7342 256.613L15.9361 259.084L21.0524 256.433Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip9_1744_16543)">
        <path
          d="M18.835 64.3327L15.4194 60.0016L9.77879 60.5907L12.9999 55.7386L11.0032 50.5365L16.4101 51.8675L20.8177 48.063L20.9382 53.7397L25.6578 56.5902L20.3261 58.7668L18.835 64.3327Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip10_1744_16543)">
        <path
          d="M362.902 68.4163L358.955 72.2697L360.136 77.8167L354.971 75.1251L350.009 77.6593L350.762 72.1422L346.514 68.1604L352.146 67.4419L354.483 62.4481L357.21 67.5205L362.902 68.4163Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip11_1744_16543)">
        <path
          d="M361.814 132.631L356.303 132.391L353.067 137.049L351.494 131.441L346.25 129.558L350.788 126.331L350.783 120.508L355.162 124.123L360.403 122.408L358.571 127.868L361.814 132.631Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip12_1744_16543)">
        <path
          d="M25.0982 180.4L20.0992 182.732L19.379 188.357L15.3949 184.109L9.87353 184.859L12.409 179.902L9.71678 174.739L15.2698 175.924L19.1267 171.984L20.0226 177.672L25.0982 180.4Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip13_1744_16543)">
        <path
          d="M351.087 254.975L350.763 249.469L345.799 246.725L351.217 244.588L352.555 239.179L356.228 243.363L362.02 242.764L358.871 247.489L361.112 252.527L355.494 251.263L351.087 254.975Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip14_1744_16543)">
        <path
          d="M27.8545 545.242L23.664 541.655L18.2446 543.326L20.4641 537.942L17.4968 533.225L23.0591 533.483L26.6456 528.896L27.8643 534.442L33.0469 536.324L28.2383 539.492L27.8545 545.242Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip15_1744_16543)">
        <path
          d="M355.086 548.489L358.333 544.03L356.242 538.758L361.784 540.549L366.253 537.221L366.432 542.786L371.286 546.002L365.853 547.652L364.384 552.966L360.847 548.421L355.086 548.489Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip16_1744_16543)">
        <path
          d="M8.83102 500.103L11.3878 495.215L8.54488 490.308L14.2898 491.265L18.2215 487.316L19.2166 492.795L24.4902 495.263L19.3585 497.693L18.6859 503.165L14.5202 499.189L8.83102 500.103Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip17_1744_16543)">
        <path
          d="M357.75 469.002L361.671 472.881L367.197 471.605L364.595 476.816L367.214 481.734L361.685 481.076L357.777 485.392L356.961 479.773L351.928 477.522L356.953 474.708L357.75 469.002Z"
          fill="#FBE200"
        />
      </g>
      <defs>
        <clipPath id="clip0_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(32.5186 16.0356) rotate(158.129)"
          />
        </clipPath>
        <clipPath id="clip1_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(194.72 18.4863) rotate(155.421)"
          />
        </clipPath>
        <clipPath id="clip2_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(296.287 25.5077) rotate(-169.422)"
          />
        </clipPath>
        <clipPath id="clip3_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(16.6362 139.634) rotate(-145.659)"
          />
        </clipPath>
        <clipPath id="clip4_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(369.938 20.2229) rotate(121.286)"
          />
        </clipPath>
        <clipPath id="clip5_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(101.291 26.7098) rotate(-73.4712)"
          />
        </clipPath>
        <clipPath id="clip6_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(252.731 19.5469) rotate(118.014)"
          />
        </clipPath>
        <clipPath id="clip7_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(363.966 196.036) rotate(-179.769)"
          />
        </clipPath>
        <clipPath id="clip8_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(25.2139 272.268) rotate(178.539)"
          />
        </clipPath>
        <clipPath id="clip9_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(4.3335 56.7322) rotate(-49.0759)"
          />
        </clipPath>
        <clipPath id="clip10_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(356.873 83.6385) rotate(-145.129)"
          />
        </clipPath>
        <clipPath id="clip11_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(346.59 138.655) rotate(-98.3226)"
          />
        </clipPath>
        <clipPath id="clip12_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(14.3745 192.772) rotate(-125.818)"
          />
        </clipPath>
        <clipPath id="clip13_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(343.54 240.445) rotate(-14.1828)"
          />
        </clipPath>
        <clipPath id="clip14_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(12.1548 540.597) rotate(-60.2535)"
          />
        </clipPath>
        <clipPath id="clip15_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(358.485 532.473) rotate(25.2485)"
          />
        </clipPath>
        <clipPath id="clip16_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(9.84082 483.761) rotate(16.8006)"
          />
        </clipPath>
        <clipPath id="clip17_1744_16543">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="translate(373.074 474.767) rotate(123.882)"
          />
        </clipPath>
      </defs>{' '}
    </svg>
  );
};

export default StarsConfetti;
